import { inject } from '@angular/core';
import { BiCoreConfig } from '@wonder-bi-front/config';
import { environment } from './environment/environment';
import { iframeConfig } from './environment/iframe-config';
import { TenantSelectionService } from './session/tenant-selection.service';

/**
 * Configuration of the WonderBI core. Its `defaultTenant` is what the core screens (dashboards, queries,
 * events...) read when they are created, so it follows the tenant the user works in: the default one of
 * the deployment, or the one a SUPER_ADMIN picked at login.
 */
export function biCoreConfigFactory(): BiCoreConfig {
  const tenant = inject(TenantSelectionService);
  return {
    apiBaseUrl: environment.api,
    mapbox: environment.mapboxToken
      ? { token: environment.mapboxToken, styleUrl: environment.mapboxStyleUrl }
      : null,
    iframeEnabled: iframeConfig.enabled,
    get defaultTenant() {
      return tenant.current();
    },
    themeSelectorEnabled: environment.themeSelectorEnabled,
  };
}
